import { render } from "./CustomerPortal.vue?vue&type=template&id=5bab3808&ts=true"
import script from "./CustomerPortal.vue?vue&type=script&lang=ts"
export * from "./CustomerPortal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__